var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          staticClass: "change-button",
          on: {
            click: function ($event) {
              _vm.showModal = true
            },
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.$t("button.createUser")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "create-user-modal-window",
          attrs: {
            centered: "",
            title: _vm.$t("title.userCreation"),
            "hide-footer": "",
          },
          on: { hidden: _vm.resetForm },
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _c("ValidationObserver", {
            ref: "creationObserver",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ valid }) {
                  return [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.handleSubmit.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "is-teacher-checkbox",
                                attrs: { switch: "" },
                                model: {
                                  value: _vm.isTeacher,
                                  callback: function ($$v) {
                                    _vm.isTeacher = $$v
                                  },
                                  expression: "isTeacher",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("title.teacherRegister")) +
                                    "\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "is-teacher-checkbox mb-3",
                                attrs: { switch: "" },
                                model: {
                                  value: _vm.passwordCreation,
                                  callback: function ($$v) {
                                    _vm.passwordCreation = $$v
                                  },
                                  expression: "passwordCreation",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("title.passwordCreation")) +
                                    "\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-input", {
                              attrs: {
                                type: "text",
                                ind: "name",
                                rules: "required",
                                placeholder: _vm.$t("placeholder.name"),
                                autocomplete: "off",
                              },
                              model: {
                                value: _vm.form.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "name", $$v)
                                },
                                expression: "form.name",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-input", {
                              attrs: {
                                type: "text",
                                ind: "surname",
                                rules: "required",
                                placeholder: _vm.$t("placeholder.surname"),
                                autocomplete: "off",
                              },
                              model: {
                                value: _vm.form.surname,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "surname", $$v)
                                },
                                expression: "form.surname",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-input", {
                              attrs: {
                                ind: "mail",
                                type: "text",
                                required: "",
                                autocomplete: "off",
                                rules: "required|email|emailNotExists",
                                placeholder: _vm.$t("placeholder.email"),
                              },
                              model: {
                                value: _vm.form.mail,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "mail", $$v)
                                },
                                expression: "form.mail",
                              },
                            }),
                            _vm._v(" "),
                            _vm.passwordCreation
                              ? _c("v-input", {
                                  attrs: {
                                    ind: "password",
                                    type: "text",
                                    placeholder: _vm.$t("placeholder.password"),
                                    rules: { required: true, min: 6 },
                                    autocomplete: "off",
                                  },
                                  model: {
                                    value: _vm.form.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "password", $$v)
                                    },
                                    expression: "form.password",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isTeacher
                          ? _c(
                              "div",
                              [
                                _c("v-input", {
                                  attrs: {
                                    type: "text",
                                    ind: "work.place",
                                    rules: "required",
                                    placeholder: _vm.$t("placeholder.work"),
                                    autocomplete: "off",
                                  },
                                  model: {
                                    value: _vm.form.work,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "work", $$v)
                                    },
                                    expression: "form.work",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-input", {
                                  attrs: {
                                    type: "text",
                                    ind: "work.position",
                                    rules: "required",
                                    placeholder: _vm.$t("placeholder.position"),
                                    autocomplete: "off",
                                  },
                                  model: {
                                    value: _vm.form.position,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "position", $$v)
                                    },
                                    expression: "form.position",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-input", {
                                  attrs: {
                                    type: "text",
                                    ind: "phone",
                                    rules: "required|phone",
                                    placeholder: _vm.$t("placeholder.phone"),
                                    autocomplete: "off",
                                  },
                                  model: {
                                    value: _vm.form.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "phone", $$v)
                                    },
                                    expression: "form.phone",
                                  },
                                }),
                                _vm._v(" "),
                                _c("b-form-textarea", {
                                  staticClass: "mb-3",
                                  attrs: {
                                    id: "comment",
                                    rows: "3",
                                    placeholder: _vm.$t("placeholder.comment"),
                                  },
                                  model: {
                                    value: _vm.form.comment,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "comment", $$v)
                                    },
                                    expression: "form.comment",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-end" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  type: "submit",
                                  variant: "primary",
                                  disabled: !valid,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("button.save")) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }